module.exports = __webpack_public_path__ + "static/media/bus.e448fe18.svg";